export default {
  setHotSiteToken (state, payload) {
    state.hotSiteToken = payload
  },
  loadAvaliableSchedule (state, payload) {
    state.avaliableSchedule = payload
  },
  loadItem (state, payload) {
    state.item = payload
    state.item.priceTable = payload.itemFornecedor.priceTable
    state.item.paymentsViewModel = payload.itemFornecedor.paymentsViewModel
    if (payload.itemFornecedor.priceTable && payload.itemFornecedor.priceTable.length > 0) {
      state.itemChoosen = payload.itemFornecedor.priceTable[0].provider
    }
    state.dateChoosen = state.item.dates[0]
  },
  loadClient (state, payload) {
    state.client = payload
  },
  toggleLoadingCheckout (state, value) {
    state.loadingCheckout = value
  },
  updateTimeChoosen (state, value) {
    state.timeChoosen = value
  },
  updateDateChoosen (state, value) {
    state.dateChoosen = value
  },
  updatePaymentChoosen (state, value) {
    state.paymentChoosen = value
  },
  updateItemChoosen (state, value) {
    state.itemChoosen = value
  },
  updateUnityChoosen (state, value) {
    state.unityChoosen = value
  },
  updateAcceptance (state, value) {
    state.acceptance = value
  },
  toggleRequestSentModal (state, value) {
    state.requestSentModal = value
  },
  toggleLoadingOrderRequest (state, value) {
    state.loadingOrderRequest = value
  }
}



// WEBPACK FOOTER //
// ./src/store/Checkout/mutations.js